import * as PNotifyMobile from '@pnotify/mobile';
import * as PNotify from '@pnotify/core';
import * as PNotifyBootstrap4 from '@pnotify/bootstrap4';

PNotify.defaultModules.set(PNotifyBootstrap4, {});
PNotify.defaultModules.set(PNotifyMobile, {});

export const pNotify = PNotify;